import Hotjar from "@ea/hotjar";
export function loadHotJar(siteId: number, version = 6) {
  try {
    Hotjar.init(siteId, version, { nonce: "4f529tZSjbf29sIF4N0ctgryjyuyB3auyrxjyjr432fd" });
  } catch (err) {
    console.error(err);
  }
}
